/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_Ca_FrInputs */



/**
* | output |
* | --- |
* | "Canadian French" |
*
* @param {Subtitle_Export_Vchip_Type_Ca_FrInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_ca_fr = /** @type {((inputs?: Subtitle_Export_Vchip_Type_Ca_FrInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_Ca_FrInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Français canadien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kanadisches Französisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("francese canadese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("канадский французский")
	if (locale === "es") return /** @type {LocalizedString} */ ("francés canadiense")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加拿大法语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カナダフランス語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनाडाई फ्रेंच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Francês canadense")
	return /** @type {LocalizedString} */ ("Canadian French")
});